$(function(){
  $(document).on('click','.c_colabgalery-img',function(){
    $(this).parent().find('.u_colab_popup_wrapper').show()
     $(this).parents('.c_colabgalery-a').addClass('u_active_block');
    $('body').attr('style','overflow:hidden')
  })
    $(document).on('click','.u_colab_popup_overlay,.u_colab_popup_close',function(){
    $(this).parents('.c_colabgalery-a').find('.u_colab_popup_wrapper').hide()
       $('body').attr('style','overflow:visible')
      $('.c_colabgalery-a').removeClass('u_active_block');
  })
      $(document).on('click','.u_colab_right_arrrow',function(){
  $(this).parents('.c_colabgalery').find(".c_colabgalery-a").each(function(){
      if($(this).hasClass("u_active_block") && $(this).next().hasClass("c_colabgalery-a")){
        $(this).removeClass("u_active_block");
        $(this).next().addClass("u_active_block");
        return false;
      }
        });
 $(this).parents('.c_colabgalery').find(".c_colabgalery-a").each(function(){
      if($(this).hasClass("u_active_block") && !$(this).next().hasClass("c_colabgalery-a")){
        if($(this).hasClass("u_last_img")){
          console.log('last img')
     $(this).find('.u_colab_left_arrrow').removeClass('u_disabled_arrow')
        $(this).find('.u_colab_right_arrrow').addClass('u_disabled_arrow')
          return false;     
        }
      }
        });
          $(this).parents('.c_colabgalery-a').find('.u_colab_popup_wrapper').hide()
        $(this).parents('.c_colabgalery-a').removeClass('u_active_block');
    $(this).parents('.c_colabgalery-a').next().addClass('u_active_block').find('.u_colab_popup_wrapper').show()
  })
        $(document).on('click','.u_colab_left_arrrow',function(){
 $(this).parents('.c_colabgalery').find(".c_colabgalery-a").each(function(){
      if($(this).hasClass("u_active_block") && $(this).prev().hasClass("c_colabgalery-a")){
        $(this).removeClass("u_active_block");
        $(this).prev().addClass("u_active_block");
        return false;
      }
    });
 $(this).parents('.c_colabgalery').find(".c_colabgalery-a").each(function(){
      if($(this).hasClass("u_active_block") && !$(this).prev().hasClass("c_colabgalery-a")){
        if($(this).hasClass("u_first_img")){
          console.log('first imag')
   $(this).find('.u_colab_left_arrrow').addClass('u_disabled_arrow')
        $(this).find('.u_colab_right_arrrow').removeClass('u_disabled_arrow')
          return false;     
        }
      }
        });
          $(this).parents('.c_colabgalery-a').find('.u_colab_popup_wrapper').hide()
        $(this).parents('.c_colabgalery-a').removeClass('u_active_block');
    $(this).parents('.c_colabgalery-a').prev().addClass('u_active_block').find('.u_colab_popup_wrapper').show()
  })
  //product add to cart
 $(document).on("click",".u_colab_atc_btn_size",function() {
  console.log('product atc')
       var vid = $(this).attr('var-id');
  let ths = $(this)
   $.ajax({
url:'/cart/add.js',
type:'post',
dataType:'json',
data:{
        quantity: 1, 
        id: vid
},
    success:function(){
      console.log('addon product addedd successfully');  
           document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
                  $(".header__icon-wrapper[aria-controls='mini-cart']").attr("aria-expanded" , "true");
              setTimeout(function(){
                jQuery.getJSON('/cart.js', function(cart) {
                  console.log(cart.item_count);
                  $('.header__cart-count').text(cart.item_count);
                });
              }, 1000);
    },
       error:function(err){
          console.log("Error",err);
          let res_err = err.responseText;
      let f_err = JSON.parse(res_err)
           console.log("Error",f_err);
        }

})         
    });
})